import { ActionContext } from 'vuex';
import router from '../../../router';
import { ConfigMutations } from '../config/mutations';
import axios, { AxiosError, AxiosResponse } from 'axios';
import { generateNotificationItem, NOTIFICATION_TYPES } from '@/models/AppConfig';
import { AppState } from '@/models/TechnicianAppState';
import config from '@/config';
import { STATE_MODULES } from '@/store/state-modules';
import { LoginMutations } from './mutations';
import { LoginState } from '@/models/LoginState';
import { LOGIN_COOKIE_NAME, OFFERED_LEADS_TOPUP_COOKIE_NAME } from '@/constants/utils';
import Cookies from 'js-cookie';
import { TechnicianMutations } from '../technician/mutations';
import ModalManager from '@/utils/modal';
import OutOfLeads from '@/components/modals/OutOfLeads.vue';
import { technicianUtils } from '@puls/puls-general-utils';
import TopUp from '@/components/modals/TopUp.vue';
import utils from '@/utils/utils';
import leadsConstants from '../../../constants/leads';

export const LoginActions = {
	INIT_USER: 'INIT_USER',
	LOGIN: 'LOGIN',
	LOGOUT: 'LOGOUT',
	VERIFY_CODE: 'VERIFY_CODE'
}

export const LOGIN_CODE_VERIFICATION_URL = "/portal/technician/login-verification"

export default {
	async [LoginActions.INIT_USER] (context: ActionContext<LoginState, AppState>) {
		try { 
			const result = await axios.get(`${config.api}/portal/technician/details`)

			if (!result.data) { 
				throw new Error('Failed to load technician');
			}
			
			try {
				const w: any = window;
				w.dataLayer.push({
					event: 'CE Technician Portal Opened',
					"appointment email": result.data.email
				})
			} catch (error) {
				
			}

			// update the technician object
			context.commit(`${STATE_MODULES.TECHNICIAN}/${TechnicianMutations.UPDATE_DETAILS}`, result.data, { root: true });
			// update the jwt of the tech
			// context.commit(`${STATE_MODULES.LOGIN}/${LoginMutations.UPDATE_LOGIN_DETAILS}`, jwt, { root: true });
			const showTopUp = Cookies.get(OFFERED_LEADS_TOPUP_COOKIE_NAME);
			if (!showTopUp) { 
				const { service_provider_id, remaining_leads_count } = result.data;
				if (technicianUtils.isLeadPartner(service_provider_id) && !remaining_leads_count) { 
					ModalManager.open(OutOfLeads, {}, (result: boolean) => {
						if (result) { 
							ModalManager.open(TopUp, { plansToShow: leadsConstants.LEADS_PLANS_TO_SHOW.NO_REMAINING_LEADS })
						}
						const cookieExpire = 15 * 60 * 60 * 24 * 1000;
						Cookies.set(OFFERED_LEADS_TOPUP_COOKIE_NAME, 'true', { expires: cookieExpire })
					})
				}
			}
		} catch (err: any) {
			context.commit(
				`${STATE_MODULES.CONFIG}/${ConfigMutations.ADD_NOTIFICATION}`,
				generateNotificationItem({ type: NOTIFICATION_TYPES.error, message: err.message || "Something wnet wrong!" }),
				{ root: true }
			);
		}
	},
	[LoginActions.LOGOUT] (/* context: ActionContext<LoginState, AppState> */) {
		utils.logout();
	},
	[LoginActions.LOGIN] (context: ActionContext<LoginState, AppState>) {
		const params = { [context.getters.COMMUNICATION_TYPE]: context.getters.COMMUNICATION };
		axios.post(`${config.api}/portal/technician/verification-code`, params).then((response: AxiosResponse<any>) => {
			if (response.data.ok) {
				const return_url = router.instance.currentRoute.value.query.return_url;
				let verificationRoute = '/login/verification';
				if (return_url) {
					verificationRoute += `?return_url=${return_url}`;
				}
				router.instance.push(verificationRoute);
				context.commit(
					`${STATE_MODULES.CONFIG}/${ConfigMutations.ADD_NOTIFICATION}`,
					generateNotificationItem({ type: NOTIFICATION_TYPES.info, message: `Verification sent to ${Object.values(params)[0]}` }),
					{ root: true }
				);
			} else {
				context.commit(
					`${STATE_MODULES.CONFIG}/${ConfigMutations.ADD_NOTIFICATION}`,
					generateNotificationItem({ type: NOTIFICATION_TYPES.error, message: response.data.message || "Something wnet wrong!" }),
					{ root: true }
				);
			}
		}).catch((err: AxiosError<any>) => {
			context.commit(
				`${STATE_MODULES.CONFIG}/${ConfigMutations.ADD_NOTIFICATION}`,
				generateNotificationItem({ type: NOTIFICATION_TYPES.error, message: err.response?.data?.message || "Something wnet wrong!", code: err.response?.data?.error_code }),
				{ root: true }
			)
		})
	},
	[LoginActions.VERIFY_CODE] (context: ActionContext<LoginState, AppState>, payload: string) {
		const params = {
			code: payload,
			[context.getters.COMMUNICATION_TYPE]: context.state.communication,
			uuid: "123"
		}
		axios.post(`${config.api}${LOGIN_CODE_VERIFICATION_URL}`, params).then((result: AxiosResponse<any>) => {
			const data: any = result.data;
			if (data.ok) {
				Cookies.set(LOGIN_COOKIE_NAME, data.token, { expires: new Date(data.token_expiry) });
				context.commit(`${STATE_MODULES.LOGIN}/${LoginMutations.UPDATE_LOGIN_DETAILS}`, data.token, { root: true });
				const redirectTo = router.instance.currentRoute.value.query.return_url as string || '/';
				router.instance.replace(redirectTo);
			} else {
				context.commit(
					`${STATE_MODULES.CONFIG}/${ConfigMutations.ADD_NOTIFICATION}`,
					generateNotificationItem({ type: NOTIFICATION_TYPES.error, message: data.message || "Something wnet wrong!" }),
					{ root: true }
				)
			}
		}).catch((err: AxiosError<any>) => {
			context.commit(
				`${STATE_MODULES.CONFIG}/${ConfigMutations.ADD_NOTIFICATION}`,
				generateNotificationItem({ type: NOTIFICATION_TYPES.error, message: err.response?.data?.message || "Something wnet wrong!", code: err.response?.data?.error_code }),
				{ root: true }
			)
		})
	}
}
